import { useNavigate } from 'react-router-dom'
import { ClipboardCheck } from "lucide-react";
import { CalculateAssessmentScore } from 'functions/assessmentSummaryUtils'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { GetDateTimeDisplay } from 'functions/textUtils'
import moment from 'moment'

export default function AssessmentListItem({ assessment }) {
    const navigate = useNavigate()

    const assessmentTemplateData = assessment.assessmentTemplateData || {}
    const assessmentName = assessmentTemplateData.name || assessment.name
    const createdTimestamp = assessment.createdTimestamp || assessment.timestamp
    const assessmentScore = CalculateAssessmentScore(assessmentTemplateData)

    const OnViewAssessmentButton = () => {
        const props = {
            state: {
                assessmentUIFlowKey: 'list',
                assessmentWorkoutTemplate : assessmentTemplateData
            }
        }

        navigate('/assessment/summary', props)
    }

    return (
        <div 
            className="w-full flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
            onClick={() => OnViewAssessmentButton()}
        >
            <div className="h-12 w-12 bg-orange-400 rounded-full items-center">
                <ClipboardCheck className="h-6 m-3 text-white" />
            </div>

            <div className="flex-grow">
                <p className="font-lg font-semibold">{assessmentName}</p>
                <p className="text-sm">{assessment.firstName} {assessment.lastName}</p>
            </div>

            <div className="flex items-center gap-x-4 pr-4">
                <p className="w-24 text-left text-sm">Score: {assessmentScore}%</p>

                <div className="w-32 h-3 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                        className="h-full bg-orange-400 rounded-full"
                        style={{ width: `${assessmentScore}%` }}
                    />
                </div>

            </div>

            {moment.utc(createdTimestamp).local().isValid() && (
                <p className="w-64 text-left text-sm">{GetDateTimeDisplay(createdTimestamp)}</p>
            )}
            
            <ChevronRightIcon className="text-gray-400 h-8" />
        </div>
    )
}